// This file contains the stuff to manage auth tokens and the current user
import { BehaviorSubject } from 'rxjs';
import { useState, useEffect } from 'react';

// This is the token response from Alli Central, which will contains both
// an access and refresh token as well as info about when it expires
export const accessToken = new BehaviorSubject(null);

// should an application need the access token, this hook
// is how to obtain it.
export function useAccessToken() {
    const [token, setToken] = useState(accessToken.getValue());

    useEffect(() => {
        const observer = accessToken.subscribe(t => setToken(t));
        return () => observer.unsubscribe();
    }, [setToken]);

    return token;
}

const FIVE_MINUTES_IN_SECONDS = 300;

/**
 * @param {int} expiresIn the number of seconds in the future that the token expires
 * @return DateTime
 */
function computeExpiresIn(expiresIn) {
    let now = new Date();
    // adjust our expires in to be five minutes sooner so we have some buffer
    let expiresInMs = (expiresIn - FIVE_MINUTES_IN_SECONDS) * 1000;
    now.setTime(now.getTime() + expiresInMs);

    return now;
}

export class AccessToken {
    constructor(accessToken, tokenType, refreshToken, expiresIn, idToken) {
        this.accessToken = accessToken;
        this.tokenType = tokenType;
        this.refreshToken = refreshToken;
        this.expiration = computeExpiresIn(expiresIn);
        this.idToken = idToken;
    }

    static fromTokenResponse({
        access_token,
        token_type,
        refresh_token,
        expires_in,
        id_token,
    }) {
        return new AccessToken(
            access_token,
            token_type,
            refresh_token,
            expires_in,
            id_token,
        );
    }

    authorizationHeader() {
        return `${this.tokenType} ${this.accessToken}`;
    }

    isExpired() {
        let now = new Date();
        return now >= this.expiration;
    }
}
